import React from 'react';
import { Link } from 'react-router-dom';
import './ISO28001.css';

const ISO28001 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 28001 Supply Chain Security Management System</h1>
            <h2 className="page-subtitle">Secure Supply Chain, Guaranteed by NQC</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we are providing a detailed review of the 
                ISO 28001 Supply Chain Security Management System to ensure businesses achieve top-level 
                performance in supply chain security.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 28001?</h2>
            <div className="page-text-content">
              <p>
                ISO 28001 is a management system designed to secure a business's supply chain processes. 
                This international standard addresses the need to ensure the security of material and 
                information flow within the global supply chain. By implementing ISO 28001, businesses 
                can identify, assess, and effectively manage potential threats in the supply chain.
              </p>
              <p>
                ISO 28001 guides businesses in establishing security policies and procedures. It 
                encourages regular training for employees and increasing security awareness. Moreover, 
                following the principle of continuous improvement, it enables businesses to regularly 
                assess and improve their security performance.
              </p>
              <p>
                One of the key focuses of ISO 28001 is the analysis and assessment of threats. By 
                identifying potential threats they may encounter in the supply chain processes, 
                businesses can take effective measures against these threats.
              </p>
              <p>
                In conclusion, the ISO 28001 Supply Chain Security Management System offers a 
                comprehensive solution for businesses to enhance security in the global supply chain 
                and strengthen customer trust.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Elements of ISO 28001</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Threat Analysis and Assessment</h3>
                <p className="element-description">
                  ISO 28001 allows businesses to identify possible threats throughout the supply chain 
                  and assess these threats, enabling more effective planning of security measures.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Security Policies and Procedures</h3>
                <p className="element-description">
                  The standard guides businesses in creating security policies and procedures aligned 
                  with company objectives.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Training and Awareness</h3>
                <p className="element-description">
                  ISO 28001 encourages training sessions to increase security awareness among employees, 
                  fostering a security culture.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Continuous Improvement</h3>
                <p className="element-description">
                  The standard enables continuous assessment and improvement of supply chain security 
                  performance to adapt to changing threats.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 28001 and Secure Supply Chain</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Risk Management</h3>
                <p className="advantage-description">
                  Threat analysis and assessment help businesses proactively identify and manage risks.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Competitive Advantage</h3>
                <p className="advantage-description">
                  ISO 28001 certification provides a competitive edge by demonstrating commitment to 
                  supply chain security.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Cost-effectiveness</h3>
                <p className="advantage-description">
                  Security policies and continuous improvement help businesses find cost-effective 
                  solutions.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO28001;

